module.exports = __webpack_public_path__ + "media/images/front/services/installation-04f8a95541c680b24c947c5f4650b93e.webp";